import React from "react";

const timeline = [
    {
      d: "Day 01–04",
      t: "Basic Electronics",
      desc: "SMD components, multimeter, tools & safety."
    },
    {
      d: "Day 05–08",
      t: "Power Section",
      desc: "PMIC, battery, boot circuits and dead-phone diagnosis."
    },
    {
      d: "Day 09–12",
      t: "Charging Problems",
      desc: "USB, Tristar, Tigris IC, charging IC replacement."
    },
    {
      d: "Day 13–16",
      t: "Network & Audio",
      desc: "Signal circuits, PA modules, audio codecs, mic/speaker."
    },
    {
      d: "Day 17–20",
      t: "CPU & eMMC",
      desc: "Reballing, ISP programming, data recovery."
    },
    {
      d: "Day 21–25",
      t: "Live Repair & Certification",
      desc: "Customer handsets, exam, placement preparation."
    }
  ];




  function Timeline() {
    return (


            <section className="timeline-section scroll-reveal">

            <div className="timeline-container scroll-reveal">
 
                <div className="timeline-header scroll-reveal">

                <div className="timeline-subtitle scroll-reveal">
                    What You'll Learn
                </div>

                <h2 className="timeline-title scroll-reveal">
                    The 25-Day Transformation
                </h2>

                <p className="timeline-description scroll-reveal">
                    Fast-track curriculum designed for industry readiness —
                    from opening your first handset to certifying on live
                    customer repairs.
                </p>

                </div>

                <div className="timeline scroll-reveal">

                {timeline.map((item, index) => (

                    <div
                    className={`timeline-item ${
                        index === timeline.length - 1 ? "last-item" : ""
                    }`}
                    key={item.d}
                    >

                    <div
                        className={`timeline-dot
                        ${index === 0 ? "start" : ""}
                        ${index === timeline.length - 1 ? "end" : ""}
                        `}
                    ></div>

                    <div
                        className={`timeline-day
                        ${index === 0 ? "start-text" : ""}
                        ${index === timeline.length - 1 ? "end-text" : ""}
                        `}
                    >
                        {item.d}
                    </div>

                    <h4>{item.t}</h4>

                    <p>{item.desc}</p>

                    </div>

                ))}

                </div>

                <div className="timeline-button scroll-reveal">

                <a href="/curriculum" className="curriculum-btn scroll-reveal">
                    View Full Curriculum
                </a>

                </div>

            </div>

          </section>

)
}

export default Timeline;